import template from './template.html';

import BlockBox from '../box';
import BlockTechnologies from '../technologies';
import BlockTestimonials from '../testimonials';
import BlockClients from '../clients';
import BlockAdvantages from '../advantages';
import BlockFaq from '../faq';
import BlockAction from '../action';
import BlockTeam from '../team';
import BlockFacts from '../facts';
import BlockSteps from '../steps';
import BlockLocations from '../locations';
import BlockContact from '../contact';
import BlockIntro from '../intro';
import BlockInfo from '../info';
import BlockCarousel from '../carousel';
import BlockCases from '../cases';
import BlockCalculator from '../calculator';
import BlockRegular from '../regular';

export default {
    name: 'stream',
    template: template,

    props: {
        blocks: Array,
    },

    components: {
        BlockBox,
        BlockTechnologies,
        BlockTestimonials,
        BlockClients,
        BlockAdvantages,
        BlockFaq,
        BlockAction,
        BlockTeam,
        BlockFacts,
        BlockSteps,
        BlockLocations,
        BlockContact,
        BlockIntro,
        BlockInfo,
        BlockCarousel,
        BlockCases,
        BlockCalculator,
        BlockRegular,
    },
    
    methods: {
        getBlockName(block) {
            let layout = block.acf_fc_layout;
            return `block-${layout}`;
        }
    },

    computed: {
        menuState() {
            return this.$store.getters.getMainNavState();
        },
    },
};